import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { Coordinates } from '../../../../../viewer/utilities/math-helpers';
import { useUnitSymbols } from '../../../../hooks/use-unit-symbols';
import { CoordinatePropertiesStyled } from './coordinate-properties';
import { Slope } from './design-hover-properties';

export type LineProps = {
  type: 'line';
  length: number;
  planeLength: number;
  slope: number;
};

export const LineProperties = (props: {
  coordinate: Coordinates;
  coordinateSystem?: string;
  properties: LineProps;
}) => {
  const { t } = useTranslation();
  const unitSymbols = useUnitSymbols();
  return (
    <Component>
      <p className="height">
        <label>
          {t('assetPositionTooltip.lineProperties.height', {
            ns: 'skyview',
            unit: unitSymbols.length,
          })}
        </label>
        <span>
          {props.coordinate.height.toFixed(2)} {unitSymbols.length}
        </span>
      </p>

      <p className="length">
        <label>{t('assetPositionTooltip.lineProperties.length3d', { ns: 'skyview' })}</label>
        <span>
          {props.properties.length > 0 ? (
            <>
              <span>{props.properties.length.toFixed(2)}</span> {unitSymbols.length}
            </>
          ) : (
            '-'
          )}
        </span>
      </p>

      <p className="plane-length">
        <label>{t('assetPositionTooltip.lineProperties.length2d', { ns: 'skyview' })}</label>
        <span>
          {props.properties.planeLength > 0 ? (
            <>
              <span>{props.properties.planeLength.toFixed(2)}</span> {unitSymbols.length}
            </>
          ) : (
            '-'
          )}
        </span>
      </p>

      <Slope className="slope" slope={props.properties.slope} />
    </Component>
  );
};

const Component = styled(CoordinatePropertiesStyled)`
  grid-template-areas:
    'height             height'
    'length             plane-length'
    'slope              slope';

  .height {
    grid-area: height;
  }

  .length {
    grid-area: length;
  }

  .plane-length {
    grid-area: plane-length;
  }

  .slope {
    grid-area: slope;
  }
`;
